/* @flow */
import * as React from 'react';
import { inject, observer } from 'mobx-react';
import { observable } from 'mobx';
import { translate } from 'react-i18next';

import type { TranslatorProps } from 'react-i18next';

import type TypeActionDrawerStore from 'stores/ActionDrawerStore';
import type TypeForm from 'forms/_.extend';

import ElectroTextField from 'forms/components/inputs/ElectroTextField/ElectroTextField';
import ActionDrawerBlock from 'views/ActionDrawer/components/ActionDrawerBlock/ActionDrawerBlock';
import ActionDrawerTable from 'views/ActionDrawer/components/ActionDrawerTable/ActionDrawerTable';
import ActionDrawerFormButtons from 'views/ActionDrawer/components/ActionDrawerFormButtons/ActionDrawerFormButtons';

import styles from '../../../../ActionDrawer.module.scss';

type TypeProps = {|
  actionDrawerStore: TypeActionDrawerStore,
  form: TypeForm,
  asset: Object,
|} & TranslatorProps;

@translate()
@inject('actionDrawerStore')
@observer
export default class UnarchiveOwnedAssetForm extends React.Component<*> {
  render(): React.Fragment {
    const { t, asset, form }: TypeProps = this.props;

    const details: Array<*> = [
      [t('general:trading_account'), `${asset.account.name} ${asset.account.number}`],
      [t('general:assets.labels.number'), asset.asset_number],
      [t('general:manufacturer'), asset.manufacturer],
      [t('general:model'), asset.model],
      [t('general:labels.serial_number'), asset.serial_number],
    ];

    return (
      <React.Fragment>
        <div className={styles['action-drawer-content']}>
          <ActionDrawerBlock
            divider={true}
            gutters={true}
            heading={t('general:assets.labels.details')}
          >
            <ActionDrawerTable data={details} />
          </ActionDrawerBlock>
          <ActionDrawerBlock
            divider={true}
            gutters={true}
            heading={t('general:assets.currently_assigned_to')}
          >
            <ul>
              <li>{asset.user.name}</li>
              <li>{`${t('general:roles.labels.current_role')}: ${asset.user.role}`}</li>
            </ul>
          </ActionDrawerBlock>
          <ActionDrawerBlock gutters={true} heading={form.$('unarchiveReason').label}>
            <h5>{`${t('general:reasons.provide_reason')} *`}</h5>
            <ElectroTextField
              field={form.$('unarchiveReason.reason')}
              props={{
                rows: 3,
                multiline: true,
                label: '',
              }}
              //heading={`${ t('general:reasons.reason_for_archiving') } *`}
              //otherHeading={`${ t('general:reasons.provide_reason') } *`}
            />
          </ActionDrawerBlock>
        </div>
        <ActionDrawerFormButtons form={form} submitTxt={t('general:actions.unarchive_asset')} />
      </React.Fragment>
    );
  }
}
